<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="客户名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['name', { rules: [{ required: true, message: '请输入客户名称' }] }]"
            name="title"
            placeholder="请输入客户名称"
          />
        </a-form-item>
        <a-form-item label="联系人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['contact', { rules: [{ required: true, message: '请输入联系人' }] }]"
            name="contact"
            placeholder="请输入客户名称"
          />
        </a-form-item>
        <a-form-item label="联系电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="[
              'phone',
              { rules: [{ validator: this.handleMinSelect }], validateTrigger: ['change', 'blur'] }
            ]"
            name="phone"
            placeholder="请输入联系电话"
          />
        </a-form-item>
        <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="[
              'email',
              { rules: [{ validator: this.handleMinSelect }], validateTrigger: ['change', 'blur'] }
            ]"
            name="email"
            placeholder="请输入邮箱"
          />
        </a-form-item>
        <a-form-item label="微信号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="[
              'wechat',
              { rules: [{ validator: this.handleMinSelect }], validateTrigger: ['change', 'blur'] }
            ]"
            name="wechat"
            placeholder="请输入微信号"
          />
        </a-form-item>
        <a-form-item label="QQ" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="[
              'qq',
              { rules: [{ validator: this.handleMinSelect }], validateTrigger: ['change', 'blur'] }
            ]"
            name="qq"
            placeholder="请输入QQ号"
          />
        </a-form-item>
        <a-form-item label="来源" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-spin :spinning="selectLoading">
            <a-select
              placeholder="请选择来源"
              name="from"
              optionFilterProp="children"
              allow-clear
              v-decorator="['from', { rules: [{ required: true, message: '请选择来源' }] }]"
            >
              <a-select-option v-for="(value, key) in selectList" :key="Number(key)">{{
                value
              }}</a-select-option>
            </a-select>
          </a-spin>
        </a-form-item>
        <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="请选择类型"
            name="type"
            optionFilterProp="children"
            allow-clear
            v-decorator="['type', { rules: [{ required: true, message: '请选择类型' }] }]"
          >
            <a-select-option v-for="(d, key) in typeList" :key="Number(key)">{{ d.value }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="合作意向" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="请选择合作意向"
            name="cooperation"
            optionFilterProp="children"
            allow-clear
            v-decorator="['cooperation', { rules: [{ required: true, message: '请选择合作意向' }] }]"
          >
            <a-select-option v-for="(d, key) in cooperationList" :key="Number(key)">{{
              d.value
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            rows="4"
            name="remark"
            placeholder="请输入备注信息"
            v-decorator="['remark', { rules: [] }]"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 20 }" style="text-align: center">
          <a-button
            @click="handleSubmit(setFormValues)"
            :loading="formLoading"
            htmlType="submit"
            type="primary">提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { GoBack } from '@/components'
import { cooperation, customerTypes } from '@/utils/util'
import { form, select } from '@/mixins'

const fields = ['name', 'phone', 'email', 'wechat', 'from', 'type', 'cooperation', 'remark', 'contact', 'qq']
const apiList = {
    getInfo: '/customers/',
    create: '/customers/create',
    update: '/customers/',
    selectList: '/customers/from'
}
export default {
    name: 'CustomerForm',
    mixins: [form, select],
    components: {
        GoBack
    },
    data () {
        return {
            apiList,
            fields,
            selectLoading: false, // 分类下拉加载
            selectList: [], // 分类下拉数据
            typeList: customerTypes(), // 客户类型
            cooperationList: cooperation() // 客户类型
        }
    },
    mounted () {
        if (this.$route.params.id) {
            this.getFormData(this.$route.params.id) // 获取编辑信息
        }
        this.getSelectLists({
            url: apiList.selectList
        }) // 获取下拉分类列表
    },
    methods: {
        /**
         * 联系方式任选其一
         * @param
         * @jdy
         */
        handleMinSelect (rule, value, callback) {
            const wechat = this.form.getFieldValue('wechat')
            const phone = this.form.getFieldValue('phone')
            const email = this.form.getFieldValue('email')
            const qq = this.form.getFieldValue('qq')
            if (!value && !wechat && !phone && !email && !qq) {
                callback(new Error('电话/邮箱/微信/QQ至少填写一项'))
            } else {
                callback()
            }
        },
        /**
         * @Author: JDY
         * @Date: 2021-04-25 11:46:32
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:整理表单数据提交
         * @param  {*}
         * @return {*}
         * @param {*} values
         */
        setFormValues (values) {
            values.date = this.moment(values.date).format('YYYY-MM-DD') // 日期格式转换
        }
    }
}
</script>
